<template lang="pug">
  .root
    ArchiveBase(:liveType="liveType")

</template>

<style src="./ArchiveFund.scss" lang="scss" scoped>

</style>

<script>
import ArchiveBase from './components/ArchiveBase'
import {LIVE_TYPE} from './helper/def'

export default {
  name: "ArchiveLiveFund",
  components: {
    ArchiveBase
  },
  data() {
    return {
      liveType: LIVE_TYPE.FUND
    }
  },
  props: {},
  computed: {},
  watch: {},
  mounted() {},
  async created() {},
  updated() {},
  async destroyed() {},
  methods: {}
};
</script>
